import ActionHint from '../ActionHint';
import { POLICY_ADMIN_LABEL, POLICY_EYEBROW, POLICY_TITLE } from '../constants';
import {
  PolicyAdminLink,
  PolicyAside,
  PolicyBadge,
  PolicyCopy,
  PolicyEyebrow,
  PolicyHead,
  PolicyRoot,
  PolicyTitle,
  StepLabel,
  StepMeta,
  StepTag,
  Timeline,
  TimelineStep,
} from './styled';
import type { PolicyStripProps } from './types';
import { getPartnerIdvPolicyAdminUrl, getPolicyStrip } from './utils';

const PolicyStrip = ({ ops, partnerName }: PolicyStripProps) => {
  const view = getPolicyStrip(ops, partnerName);
  const adminUrl = getPartnerIdvPolicyAdminUrl();

  return (
    <PolicyRoot aria-label="ID Review withdrawal policy" data-testid="idv-policy-strip">
      <PolicyHead>
        <div>
          <PolicyEyebrow>{POLICY_EYEBROW}</PolicyEyebrow>
          <PolicyTitle>{POLICY_TITLE}</PolicyTitle>
          {view.copy ? <PolicyCopy>{view.copy}</PolicyCopy> : null}
        </div>
        {view.badge || adminUrl ? (
          <PolicyAside>
            {view.badge ? (
              <ActionHint title={view.badgeReason} testId="idv-policy-badge-hint">
                <PolicyBadge tone={view.badgeTone}>{view.badge}</PolicyBadge>
              </ActionHint>
            ) : null}
            {adminUrl ? (
              <PolicyAdminLink href={adminUrl} target="_blank" rel="noopener noreferrer">
                {POLICY_ADMIN_LABEL}
              </PolicyAdminLink>
            ) : null}
          </PolicyAside>
        ) : null}
      </PolicyHead>
      <Timeline>
        {view.steps.map((step) => (
          <TimelineStep
            key={step.key}
            stepState={step.state}
            data-testid={`policy-step-${step.key}`}
            data-state={step.state}
          >
            <StepLabel>{step.label}</StepLabel>
            {step.meta ? <StepMeta>{step.meta}</StepMeta> : null}
            {step.sourceLabel && step.sourceKind ? <StepTag kind={step.sourceKind}>{step.sourceLabel}</StepTag> : null}
          </TimelineStep>
        ))}
      </Timeline>
    </PolicyRoot>
  );
};

export default PolicyStrip;
